import React from "react";
import TestimonialCard from "./TestimonialCard";

const TestimonialsSection: React.FC = () => {
  return (
    <section className="w-full mx-auto px-4 sm:px-6 lg:px-16 py-20 bg-white rounded-3xl relative z-10 mt-16">
      <div className="max-w-7xl mx-auto text-center">
        <h3 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-8 tracking-tight leading-tight">
          <span className="bg-black bg-clip-text text-transparent">
            What Our Users Say
          </span>
        </h3>
        <p className="text-base text-gray-600 leading-relaxed max-w-3xl mx-auto mb-16">
          Trusted by creatives and professionals alike, our users love the simplicity, speed,
          and stunning results this tool delivers.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { name: "Jessica Carter", message: "I used the tool to create a portfolio for my photography. The layouts and ease of use are top-notch!" },
            { name: "Mark Peterson", message: "As a teacher, I found this tool perfect for designing visual aids for my students. Highly intuitive!" },
            { name: "Sophia Hernandez", message: "This app helped me combine my artwork into a professional PDF portfolio in no time. Love it!" },
            { name: "James Lee", message: "The ability to customize layouts and titles made my marketing presentation stand out!" },
            { name: "Emily Johnson", message: "Creating a family photo collage for our anniversary was quick and fun. Fantastic tool!" },
            { name: "Daniel Kim", message: "As a content writer, I merged images for my blogs seamlessly. Great for non-designers like me." },
            { name: "Olivia Brown", message: "I exported a detailed travel photo album as a high-quality PDF. It’s perfect for sharing memories!" },
            { name: "Michael Smith", message: "This app saved me hours when organizing images for a client presentation. Highly recommended!" },
            { name: "Ava Martin", message: "I created an impressive poster for our community event using this tool. Everyone loved it!" },
            { name: "William Garcia", message: "Great for organizing my designs and exporting them in professional formats. A must-have for designers!" },
            { name: "Sarah Thompson", message: "I designed a real estate brochure with images and titles effortlessly. This tool is a gem!" },
            { name: "Dr. Andrew Scott", message: "I organized my research findings into a stunning layout for a conference presentation. Great tool!" },
            { name: "Megan White", message: "Perfect for creating a customized scrapbook of my artwork to share with clients." },
            { name: "Lucas Perez", message: "The PDF export quality is amazing. I created a professional catalog for my e-commerce store!" },
            { name: "Isabella Rodriguez", message: "I combined images of my designs and exported them for a fashion portfolio. Easy and elegant!" },
          ].map((item, index) => (
            <TestimonialCard key={index} name={item.name} message={item.message} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
